import { gql } from "@apollo/client";

export const CREATE_PROFESIONAL_MONITOREO_SUGERENCIA = gql`
    mutation CreateProfesionalMonitoreoSugerencia($input: SaveProfesionalMonitoreoSugerenciaInput!) {
  createProfesionalMonitoreoSugerencia(input: $input) {
    idProfesionalMonitoreoSugerencia
  }
}
`;